// extracted by mini-css-extract-plugin
export default {"grid":"riY_B9sbv5DS6Y0gwGxB"};